import React, { useCallback } from 'react'
import * as ActivityDetailLevel from 'const/ActivityDetailLevel'
import { FormattedMessage } from 'react-intl'
import ActivitiesComponent from 'components/Activities'
import Scrollbars from 'components/Scrollbars'
import {
  ModalMenu
} from 'components/Modal'
import {
  MenuItem
} from 'components/Menu'
import Activity from './Activity'
import classes from './Activities.module.scss'
import { useLocation } from 'react-router'
import { useCardContext } from 'dataProviders/Card'

const DETAIL_LEVELS = [
  {
    id: ActivityDetailLevel.ALL,
    formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_ALL'
  },
  {
    id: ActivityDetailLevel.IMPORTANT,
    formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_IMPORTANT'
  },
  {
    id: ActivityDetailLevel.COMMENTS,
    formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_COMMENTS'
  }
]

const CardActivities = ({
  context,
  isLoaded,
  isLoading,
  lastLoadedId,
  currentUser,
  activities,
  activitiesDetailLevel,
  visitors,

  fetchActivities,
  requestChangeUserSettings
}) => {
  const location = useLocation()

  const cardContext = useCardContext()

  const handleFetchActivities = useCallback(
    () => fetchActivities({
      cardId: cardContext.id
    }),
    [fetchActivities, cardContext]
  )

  const handleDetailLevelChange = useCallback((detailLevel) => {
    requestChangeUserSettings({
      activitiesDetailLevel: detailLevel
    })
  }, [requestChangeUserSettings])

  return (
    <React.Fragment>
      <div
        className={classes.detailLevel}
      >
        <FormattedMessage id='ACTIVITY_DETAIL_LEVEL' />:
        {' '}
        <ModalMenu
          attachment='top center'
          targetAttachment='bottom center'
        >
          <a>
            <FormattedMessage
              id={
                DETAIL_LEVELS
                  .find(detailLevel => detailLevel.id === activitiesDetailLevel)
                  .formattedMessageId
              }
            />
          </a>
          {DETAIL_LEVELS.map(detailLevel =>
            <MenuItem
              key={detailLevel.id}
              active={detailLevel.id === activitiesDetailLevel}
              onClick={() => {
                requestChangeUserSettings({
                  activitiesDetailLevel: detailLevel.id
                })
              }}
            >
              <FormattedMessage
                id={detailLevel.formattedMessageId}
              />
            </MenuItem>
          )}
        </ModalMenu>
      </div>
      <Scrollbars
        className={classes.activities}
      >
        <ActivitiesComponent
          context={context}
          isLoaded={isLoaded}
          isLoading={isLoading}
          lastLoadedId={lastLoadedId}
          currentUser={currentUser}
          detailLevel={activitiesDetailLevel}
          activities={activities}
          focusActivity={location.state && location.state.focusActivity}
          activityComponent={Activity}
          visitors={visitors}
          fetchActivities={handleFetchActivities}
          onDetailLevelChange={handleDetailLevelChange}
        />
      </Scrollbars>
    </React.Fragment>
  )
}

export default CardActivities
